import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyDJpqZRxy1NiywPeql7El1FmZpDnKnG-xY",
    authDomain: "chatapp-789e7.firebaseapp.com",
    projectId: "chatapp-789e7",
    storageBucket: "chatapp-789e7.appspot.com",
    messagingSenderId: "1085744871419",
    appId: "1:1085744871419:web:30257dfbd73979a26b3d5e"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  export {auth,provider};
  export default db;